import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c08ecf6")

_pushScopeId("data-v-7c08ecf6")
const _hoisted_1 = { class: "width900px justify-start" }
const _hoisted_2 = { class: "template-list" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_4 = { class: "margin-left5px" }
const _hoisted_5 = { class: "template-more-btn" }
const _hoisted_6 = { class: "margin-right5px" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_tip_button = _resolveComponent("tip-button")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_message_template_dialog = _resolveComponent("message-template-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (item) => {
        return (_openBlock(), _createBlock(_component_tip_button, {
          key: item.ID,
          name: item.Name,
          active: item.ID == _ctx.active,
          onChoose: ($event: any) => (_ctx.choose(item)),
          onEdit: ($event: any) => (_ctx.edit(item)),
          onDelete: ($event: any) => (_ctx.deleteItem(item))
        }, null, 8, ["name", "active", "onChoose", "onEdit", "onDelete"]))
      }), 128)),
      _withDirectives(_createVNode(_component_cus_button, {
        onClick: _ctx.add,
        class: "width200px"
      }, {
        default: _withId(() => [
          _hoisted_3,
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.ProperAllTextAddTemplate), 1)
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [_vShow, _ctx.isShowAddBtn]
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _withDirectives(_createVNode(_component_cus_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreTemplate = true))
      }, {
        default: _withId(() => [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$wordList.ProperAllTextMore), 1),
          _hoisted_7
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.isNew && _ctx.allTemplateList.length > 6 && !_ctx.showMoreTemplate]
      ])
    ]),
    (_ctx.isShowMsgDialog)
      ? (_openBlock(), _createBlock(_component_message_template_dialog, {
          key: 0,
          initForm: _ctx.form,
          submitType: _ctx.submitType,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowMsgDialog = false)),
          onSuccess: _ctx.getMsgTemplate
        }, null, 8, ["initForm", "submitType", "onSuccess"]))
      : _createCommentVNode("", true)
  ]))
})